import * as React from 'react';

import IAnswer from '../../models/IAnswer';
import IAssessment from '../../models/IAssessment';
import IAssessmentElement from '../../models/IAssessmentElement';
import IAssessmentPage from '../../models/IAssessmentPage';

import {
	setAnswer as setAnswerAction,
	setAssessment as setAssessmentAction,
	setPage as setPageAction,
	updateAssessmentElement as updateAssessmentElementAction
} from './actions';
import { store } from './store';

export function useAssessmentContext() 
{
	const context = React.useContext(store);

	if (context === undefined)
		throw new Error('useAssessmentContext must be used within an AssessmentContextProvider');

	const setAnswer = (payload: IAnswer) =>
		context.dispatch(setAnswerAction(payload));

	const setAssessment = (payload: IAssessment | null) =>
		context.dispatch(setAssessmentAction(payload));

	const setPage = (payload: IAssessmentPage | null) =>
		context.dispatch(setPageAction(payload));

	const updateAssessmentElement = (payload: IAssessmentElement) =>
		context.dispatch(updateAssessmentElementAction(payload));

	return {
		assessment: context.state.assessment,
		isFirstPage: context.state.isFirstPage,
		isLastPage: context.state.isLastPage,
		page: context.state.page,
		pageActionsComplete: context.state.pageActionsComplete,
		pageAnswers: context.state.pageAnswers,
		pageIndex: context.state.pageIndex,
		totalPages: context.state.totalPages,
		setAnswer,
		setAssessment,
		setPage,
		updateAssessmentElement
	} as const;
}
